export default __webpack_public_path__ + "static/media/covid.486dcf17.png";